//#region Imports
import React, { useEffect, useState } from 'react';
import { Backdrop } from '@mui/material';
import AppLoader from '../../../components/AppLoader/AppLoader';
import { useSelector } from 'react-redux';
import { tableStyle } from '../../../style/common';
import { convertDate } from '../../../services/Functions';
import ComplaintsReportShell from './components/ComplaintsReportShell';
import APMSComplaintsFilters from './components/APMSComplaintsFilters';
import SortableDateHeader from './components/SortableDateHeader';
import { sortComplaintsByDateField } from './components/complaintSortUtils';
import '../../Report/ChangeOfAttributesStatusReport.scss';
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from '../../../images/pitc.png';
import eOpsLogo from '../../../images/eops.png';
import jsPDF from 'jspdf';
import XLSX, { boldRows } from "utils/xlsxStyled";
import { saveAs } from 'file-saver';
import "../../../style/common.scss";
import BasicTable from '../../../components/basicTable/basicTable';
import { cfpBaseUrl } from '../../../network/urls';
//#endregion

const APMSEscalatedComplaints = () => {

    const { code, token, hierarchy: userHierarchy, cfcLevelId } = useSelector((state) => state.auth);
    const hierarchy = cfcLevelId || userHierarchy;
    const companyCode = code.slice(0, 2);

    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [apmsComplaints, setApmsComplaints] = useState([]);
    const [dataGrid, setDataGrid] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const pageSize = 20;

    // Stats from API
    const [totalPending, setTotalPending] = useState(0);
    const [totalAllocated, setTotalAllocated] = useState(0);
    const [totalWorking, setTotalWorking] = useState(0);
    const [totalOnhold, setTotalOnhold] = useState(0);

    const [totalResolved, setTotalResolved] = useState(0);
    const [totalEscalatedToSDO, setTotalEscalatedToSDO] = useState(0);
    const [totalEscalatedToSE, setTotalEscalatedToSE] = useState(0);
    const [totalEscalatedToXEN, setTotalEscalatedToXEN] = useState(0);

    // Hierarchy drill-down states
    const [selectedCompanyCode, setSelectedCompanyCode] = useState('');
    const [officeCode, setOfficeCode] = useState(code);
    const [officeName, setOfficeName] = useState('');
    const [circleCode, setCircleCode] = useState('');
    const [selectedDivision, setSelectedDivision] = useState('');
    const [selectedSubDivision, setSelectedSubDivision] = useState('');
    const [sortOrder, setSortOrder] = useState(null);
    const [filteredCircles, setFilteredCircles] = useState([]);
    const [filteredDivisions, setFilteredDivisions] = useState([]);
    const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
    const [subDivisions, setSubDivisions] = useState(
        JSON.parse(window.localStorage.getItem('subDivisions')) || []
    );

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const [dateFrom, setDateFrom] = useState(getCurrentDate());
    const [dateTo, setDateTo] = useState(getCurrentDate());
    const [escalationFilter, setEscalationFilter] = useState('all'); // 'all', 'SDO', 'SE', 'XEN'
    const [statusFilter, setStatusFilter] = useState('all'); // 'all', 'Pending', 'Allocated', 'OnHold', 'Resolved', 'Working'
    const [isGoDisabled, setIsGoDisabled] = useState(false);
    const [lastAppliedFilters, setLastAppliedFilters] = useState(null);

    const getCompanies = (code) => {
        const companies = {
            '10': 'Power Information Technology Company',
            '11': 'Lahore Electric Supply Company',
            '12': 'Gujranwala Electric Power Company',
            '13': 'Faisalabad Electric Supply Company',
            '14': 'Islamabad Electric Supply Company',
            '15': 'Multan Electric Power Company',
            '26': 'Peshawar Electric Supply Company',
            '27': 'Hazara Electric Supply Company',
            '37': 'Hyderabad Electric Supply Company',
            '38': 'Sukkur Electric Power Company',
            '48': 'Quetta Electric Supply Company',
            '59': 'Tribal Electric Supply Company',
        };
        return companies[code] || '';
    };

    const getCompanyAbbr = (code) => {
        const abbr = {
            '10': 'PITC',
            '11': 'LESCO',
            '12': 'GEPCO',
            '13': 'FESCO',
            '14': 'IESCO',
            '15': 'MEPCO',
            '26': 'PESCO',
            '27': 'HAZECO',
            '37': 'HESCO',
            '38': 'SEPCO',
            '48': 'QESCO',
            '59': 'TESCO',
        };
        return abbr[code] || '';
    };

    const getLogo = (code) => {
        const logos = {
            '10': pitcLogo, '11': LESCOLOGO, '12': GEPCOLOGO, '13': FESCOLOGO,
            '14': IESCOLOGO, '15': MEPCOLOGO, '26': PESCOLOGO, '27': HAZECOLOGO,
            '37': HESCOLOGO, '38': SEPCOLOGO, '48': QESCOLOGO, '59': TESCOLOGO,
        };
        return logos[code] || MEPCOLOGO;
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    };

    const fetchAPMSComplaints = async () => {
        setViewBackdrop(true);
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                pageNumber: String(pageNumber),
                pageSize: String(pageSize),
                officeCode: String(officeCode),
                dateFrom: dateFrom,
                dateTo: dateTo,
                status: ""
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            const response = await fetch(cfpBaseUrl + "apms/getAllAPMSComplaint", requestOptions);
            const result = await response.json();


            // Handle different response formats
            let complaintsData = [];
            let records = 0;
            let pages = 1;

            if (Array.isArray(result)) {
                // Response is array directly
                complaintsData = result;
                records = result.length;
                pages = Math.ceil(result.length / pageSize) || 1;
            } else if (result.status === "200" || result.status === 200) {
                // Wrapped response with status
                complaintsData = result.data || result.complaints || [];
                records = result.totalRecords || complaintsData.length;
                pages = result.totalPages || Math.ceil(records / pageSize) || 1;
            } else if (result.data) {
                // Has data property without status check
                complaintsData = Array.isArray(result.data) ? result.data : [];
                records = result.totalRecords || complaintsData.length;
                pages = result.totalPages || Math.ceil(records / pageSize) || 1;
            } else if (result.complaints) {
                // Has complaints property
                complaintsData = Array.isArray(result.complaints) ? result.complaints : [];
                records = result.totalRecords || complaintsData.length;
                pages = result.totalPages || Math.ceil(records / pageSize) || 1;
            }

            setApmsComplaints(complaintsData);
            setTotalRecords(records);
            setTotalPages(pages);

            // Set stats from API response
            setTotalPending(result.totalPending || 0);
            setTotalAllocated(result.totalAllocated || 0);
            setTotalWorking(result.totalWorking || 0);
            setTotalOnhold(result.totalOnHold || 0);
            setTotalResolved(result.totalResolved || 0);
            setTotalEscalatedToSDO(result.totalEscalatedToSDO || 0);
            setTotalEscalatedToSE(result.totalEscalatedToSE || 0);
            setTotalEscalatedToXEN(result.totalEscalatedToXEN || 0);
        } catch (error) {
            setApmsComplaints([]);
        }
        setViewBackdrop(false);
    };

    const convertToDataGrid = () => {
        let source = apmsComplaints;
        if (sortOrder) {
            source = sortComplaintsByDateField(apmsComplaints, sortOrder, 'registeredAt');
        }

        // Apply status filter
        let filteredComplaints = source;
        if (statusFilter !== 'all') {
            filteredComplaints = filteredComplaints.filter(item => item.status === statusFilter);
        }

        // Apply escalation filter
        if (escalationFilter === 'SDO') {
            filteredComplaints = filteredComplaints.filter(item => item.escalatedTo === 'SDO');
        } else if (escalationFilter === 'SE') {
            filteredComplaints = filteredComplaints.filter(item => item.escalatedTo === 'SE');
        } else if (escalationFilter === 'XEN') {
            filteredComplaints = filteredComplaints.filter(item => item.escalatedTo === 'XEN');
        }

        const tempArray = filteredComplaints.map((item, index) => ({
            srNo: ((pageNumber - 1) * pageSize) + index + 1,
            trackingId: item.eOpsTrackingId || '-',
            ccmsTrackingId: item.ticketNo || '-',
            referenceNumber : item.referenceNo,
            meterSerialNo: item.apmsMeterSerialNo || '-',
            complaintCategoryName: item.complaintCategoryName || '-',
            complaintTypeName: item.complaintTypeName || '-',
            transformerName: item.transformerName || '-',
            feederName: item.feederName || '-',
            source: item.source || '-',
            status: item.status || '-',
            registeredBy: item.registeredBy || '-',
            registeredAt: formatDate(item.registeredAt),
            modifiedBy: item.modifiedBy || '-',
            allocatedAt: formatDate(item.allocatedAt),
            linemanRemarks: item.linemanRemarks || '-',
            subDivisionCode: item.subDivisionCode || '-',
            latitude: item.transformerMeterLatitude,
            longitude: item.transformerMetering_Logitude,
            isEscalated: item.isEscalated ? 'Yes' : 'No',
            escalatedTo: item.escalatedTo || '-',
            rawData: item
        }));
        setDataGrid(tempArray);
    };

    useEffect(() => {
        fetchAPMSComplaints();
    }, [pageNumber]);

    useEffect(() => {
        convertToDataGrid();
    }, [apmsComplaints, escalationFilter, statusFilter, pageNumber, sortOrder]);

    useEffect(() => {
        if (code != 10) {
            setOfficeName(getCompanies(companyCode) || '');
        } else if (!selectedCompanyCode) {
            setOfficeName(getCompanies('10') || 'Power Information Technology Company');
        }
    }, [code, companyCode, selectedCompanyCode]);

    useEffect(() => {
        if (code == 10 && selectedCompanyCode) {
            const fetchSubDivisions = async () => {
                setViewBackdrop(true);
                const myHeaders = new Headers();
                myHeaders.append('Authorization', token);
                const formdata = new FormData();
                formdata.append('companyCode', selectedCompanyCode);
                try {
                    const response = await fetch(
                        cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails',
                        { method: 'POST', headers: myHeaders, body: formdata, redirect: 'follow' }
                    );
                    if (response.ok) {
                        const result = await response.json();
                        if (result.status === '200') {
                            setSubDivisions(result.message);
                            const circles = result.message.reduce((acc, curr) => {
                                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                                    acc.push({
                                        circleCode: curr.circleCode,
                                        circleName: curr.circleName,
                                        companyCode: curr.companyCode,
                                    });
                                }
                                return acc;
                            }, []);
                            setFilteredCircles(circles);
                        }
                    }
                } catch (error) {
                } finally {
                    setViewBackdrop(false);
                }
            };
            fetchSubDivisions();
        } else if (code != 10 && subDivisions?.length) {
            const circles = subDivisions.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                    acc.push({
                        circleCode: curr.circleCode,
                        circleName: curr.circleName,
                        companyCode: curr.companyCode,
                    });
                }
                return acc;
            }, []);
            setFilteredCircles(circles);
        }
    }, [code, selectedCompanyCode, token]);

    const handleChangeCompany = async (e) => {
        const selectedCompany = e.target.value;
        setSelectedCompanyCode(selectedCompany);
        setCircleCode('');
        setSelectedDivision('');
        setSelectedSubDivision('');
        setFilteredDivisions([]);
        setFilteredSubDivisions([]);

        if (selectedCompany) {
            setOfficeCode(selectedCompany);
            setOfficeName(getCompanies(selectedCompany) || '');
        } else {
            setOfficeCode(code);
            setOfficeName(getCompanies('10') || '');
            setFilteredCircles([]);
        }
    };

    const handleSort = (order) => {
        setSortOrder(order);
    };

    // Initialize hierarchy dropdowns from localStorage based on user's level
    useEffect(() => {
        if (subDivisions && subDivisions.length > 0) {
            // Get circles
            const circles = subDivisions.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                    acc.push({
                        circleCode: curr.circleCode,
                        circleName: curr.circleName,
                        companyCode: curr.companyCode,
                    });
                }
                return acc;
            }, []);
            setFilteredCircles(circles);

            // For Division level users (hierarchy > 2), pre-populate divisions
            if (hierarchy > 2) {
                const userCircleCode = parseInt(String(code).substring(0, 3));
                const uniqueDivisions = subDivisions
                    .filter((item) => String(item.circleCode) === String(userCircleCode) || String(item.divisionCode).startsWith(String(code).substring(0, 3)))
                    .reduce((acc, item) => {
                        if (!acc.some((division) => division.divisionCode === item.divisionCode)) {
                            acc.push({
                                divisionCode: item.divisionCode,
                                divisionName: item.divisionName,
                                companyCode: item.companyCode,
                            });
                        }
                        return acc;
                    }, []);
                setFilteredDivisions(uniqueDivisions);
            }

            // For Subdivision level users (hierarchy > 3), pre-populate subdivisions
            if (hierarchy > 3) {
                const userDivisionCode = parseInt(String(code).substring(0, 4));
                const uniqueSubDivisions = subDivisions
                    .filter((item) => String(item.divisionCode) === String(userDivisionCode) || String(item.subDivisionCode).startsWith(String(code).substring(0, 4)))
                    .reduce((acc, item) => {
                        if (!acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)) {
                            acc.push({
                                subDivisionCode: item.subDivisionCode,
                                subDivisionName: item.subDivisionName,
                                companyCode: item.companyCode,
                            });
                        }
                        return acc;
                    }, []);
                setFilteredSubDivisions(uniqueSubDivisions);
            }
        }
    }, [subDivisions, hierarchy, code]);

    // Circle change handler
    const handleCircleChange = (e) => {
        const selectedCircleCode = e.target.value === '' ? '' : e.target.value;
        setCircleCode(selectedCircleCode);
        setSelectedDivision('');
        setSelectedSubDivision('');
        setFilteredSubDivisions([]);

        if (selectedCircleCode) {
            setOfficeCode(selectedCircleCode);
            // Filter divisions for selected circle
            const uniqueDivisions = subDivisions
                .filter((item) => item.circleCode === selectedCircleCode)
                .reduce((acc, item) => {
                    if (!acc.some((division) => division.divisionCode === item.divisionCode)) {
                        acc.push({
                            divisionCode: item.divisionCode,
                            divisionName: item.divisionName,
                            companyCode: item.companyCode,
                        });
                    }
                    return acc;
                }, []);
            setFilteredDivisions(uniqueDivisions);
        } else {
            setOfficeCode(code);
            setFilteredDivisions([]);
        }
    };

    // Division change handler
    const handleDivisionChange = (e) => {
        const selectedDivisionCode = e.target.value === '' ? '' : e.target.value;
        setSelectedDivision(selectedDivisionCode);
        setSelectedSubDivision('');

        if (selectedDivisionCode) {
            setOfficeCode(selectedDivisionCode);
            // Filter subdivisions for selected division
            const uniqueSubDivisions = subDivisions
                .filter((item) => item.divisionCode === selectedDivisionCode)
                .reduce((acc, item) => {
                    if (!acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)) {
                        acc.push({
                            subDivisionCode: item.subDivisionCode,
                            subDivisionName: item.subDivisionName,
                            companyCode: item.companyCode,
                        });
                    }
                    return acc;
                }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
        } else {
            setOfficeCode(circleCode || code);
            setFilteredSubDivisions([]);
        }
    };

    // Subdivision change handler
    const handleSubDivisionChange = (e) => {
        const selectedSubDivisionCode = e.target.value === '' ? '' : e.target.value;
        setSelectedSubDivision(selectedSubDivisionCode);

        if (selectedSubDivisionCode) {
            setOfficeCode(selectedSubDivisionCode);
        } else {
            setOfficeCode(selectedDivision || circleCode || code);
        }
    };

    const currentFilters = {
        dateFrom,
        dateTo,
        officeCode: String(officeCode),
    };

    useEffect(() => {
        if (lastAppliedFilters === null) {
            setIsGoDisabled(false);
            return;
        }

        const hasChanged =
            JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
        setIsGoDisabled(!hasChanged);
    }, [dateFrom, dateTo, officeCode, lastAppliedFilters]);

    const handleGoClick = () => {
        setLastAppliedFilters({ ...currentFilters });
        setIsGoDisabled(true);

        if (pageNumber !== 1) {
            setPageNumber(1);
        } else {
            fetchAPMSComplaints();
        }
    };

    const handleNextPage = () => {
        if (pageNumber < totalPages) {
            setPageNumber(pageNumber + 1);
        }
    };

    const handlePreviousPage = () => {
        if (pageNumber > 1) {
            setPageNumber(pageNumber - 1);
        }
    };

    const handleFirstPage = () => {
        setPageNumber(1);
    };

    const handleLastPage = () => {
        setPageNumber(totalPages);
    };

    const handleRowClick = (row) => {
    };

    // Fetch all data for export (pageSize = 999999 to get all records for date range)
    const fetchAllDataForExport = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                pageNumber: "1",
                pageSize: "999999",
                officeCode: String(officeCode),
                dateFrom: dateFrom,
                dateTo: dateTo,
                status: ""
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            const response = await fetch(cfpBaseUrl + "apms/getAllAPMSComplaint", requestOptions);
            const result = await response.json();

            let complaintsData = [];
            if (Array.isArray(result)) {
                complaintsData = result;
            } else if (result.status === "200" || result.status === 200) {
                complaintsData = result.data || result.complaints || [];
            } else if (result.data) {
                complaintsData = Array.isArray(result.data) ? result.data : [];
            } else if (result.complaints) {
                complaintsData = Array.isArray(result.complaints) ? result.complaints : [];
            }

            // Convert to grid format
            const exportData = complaintsData.map((item, index) => ({
                srNo: index + 1,
                trackingId: item.eOpsTrackingId || '-',
                ccmsTrackingId: item.ticketNo || '-',
                referenceNumber: item.referenceNo || '-',
                meterSerialNo: item.apmsMeterSerialNo || '-',
                complaintCategoryName: item.complaintCategoryName || '-',
                complaintTypeName: item.complaintTypeName || '-',
                transformerName: item.transformerName || '-',
                feederName: item.feederName || '-',
                source: item.source || '-',
                status: item.status || '-',
                registeredBy: item.registeredBy || '-',
                registeredAt: formatDate(item.registeredAt),
                escalatedTo: item.escalatedTo || '-',
                linemanRemarks: item.linemanRemarks || '-',
                subDivisionCode: item.subDivisionCode || '-'
            }));

            return exportData;
        } catch (error) {
            return [];
        }
    };

    // Export to Excel
    const exportToExcel = async () => {
        setExportLoading(true);
        const exportData = await fetchAllDataForExport();
        const ws = XLSX.utils.json_to_sheet(exportData);
        boldRows(ws, 0, 0);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "APMS Complaints");
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(data, `APMS_Complaints_${getCurrentDate()}.xlsx`);
        setExportLoading(false);
    };

    const buildExportPdf = async (shouldSave = true) => {
        setExportLoading(true);
        const allData = await fetchAllDataForExport();

        const doc = new jsPDF('landscape');
        const pageWidth = doc.internal.pageSize.getWidth();
        const padding = 10;

        doc.addImage(getLogo(companyCode), "PNG", padding, 5, 25, 15);
        doc.addImage(eOpsLogo, "PNG", pageWidth - padding - 25, 5, 25, 15);
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(companyCode), pageWidth / 2, 15, { align: "center" });
        doc.setFontSize(12);
        doc.text("APMS Escalated Complaints Report", pageWidth / 2, 22, { align: "center" });
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text(`Date: ${dateFrom || 'All'} to ${dateTo}`, pageWidth / 2, 28, { align: "center" });

        const tableData = allData.map(item => [
            item.srNo,
            item.trackingId,
            item.ccmsTrackingId,
            item.referenceNumber,
            item.meterSerialNo,
            item.complaintCategoryName,
            item.complaintTypeName,
            item.status,
            item.registeredAt,
            item.linemanRemarks
        ]);

        doc.autoTable({
            head: [['Sr.', 'Tracking ID', 'CCMS Ticket No', 'Reference No', 'Meter No.', 'Category', 'Type', 'Status', 'Registered At', 'Remarks']],
            body: tableData,
            startY: 35,
            styles: { fontSize: 8 },
            headStyles: { fillColor: [0, 57, 113] }
        });

        setExportLoading(false);
        if (shouldSave) {
            doc.save(`APMS_Escalated_Complaints_${getCurrentDate()}.pdf`);
            return null;
        }
        return doc;
    };

    const exportToPDF = () => buildExportPdf(true);

    const printPDF = async () => {
        const doc = await buildExportPdf(false);
        if (!doc) return;
        const pdfUrl = doc.output('bloburl');
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.src = pdfUrl;
        document.body.appendChild(iframe);
        iframe.onload = () => {
            iframe.contentWindow?.print();
        };
    };

    const noDataAvailable = () => {
        alert("No data available to export or print.");
    };

    // Stats are now fetched from API: totalPending, totalWorking, totalEscalatedToSOC, totalEscalatedToSE, totalEscalatedToXEN

    // Table column definitions
    const tblColumns = [
        { field: "srNo", headerName: 'Sr No', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '50px', maxWidth: '60px' } },
        { field: "trackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '130px', maxWidth: '150px' } },
        { field: "ccmsTrackingId", headerName: 'CCMS Ticket No', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '130px', maxWidth: '150px' } },
        { field: "referenceNumber", headerName: 'Reference Number', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '130px', maxWidth: '150px' } },

        { field: "meterSerialNo", headerName: 'Meter No', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "complaintCategoryName", headerName: 'Category', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "complaintTypeName", headerName: 'Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "transformerName", headerName: 'Transformer', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '150px', maxWidth: '180px' } },
        { field: "source", headerName: 'Source', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '70px', maxWidth: '80px' } },
        {
            field: "status", headerName: 'Status', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '90px', maxWidth: '100px' },
            renderCell: (row) => (
                <span style={{
                    backgroundColor: row.status === 'Resolved' ? '#28a745' :
                        row.status === 'Pending' ? '#ffc107' :
                            row.status === 'Working' ? '#17a2b8' :
                                row.status === 'Allocated' ? '#007bff' : '#6c757d',
                    color: row.status === 'Pending' ? '#000' : 'white',
                    padding: '4px 10px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    fontWeight: 'bold'
                }}>
                    {row.status}
                </span>
            )
        },
        {
            field: "escalatedTo", headerName: 'Escalated To', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '90px', maxWidth: '100px' },
            renderCell: (row) => (
                <span style={{
                    backgroundColor: row.escalatedTo === 'SDO' ? '#fd7e14' :
                        row.escalatedTo === 'SE' ? '#dc3545' :
                            row.escalatedTo === 'XEN' ? '#6f42c1' : '#6c757d',
                    color: 'white',
                    padding: '4px 10px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    fontWeight: 'bold'
                }}>
                    {row.escalatedTo}
                </span>
            )
        },
        {
            field: "registeredAt",
            headerName: (
                <SortableDateHeader label="Registered At" sortOrder={sortOrder} onSort={handleSort} />
            ),
            align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '120px', maxWidth: '140px' }
        },
        { field: "linemanRemarks", headerName: 'Remarks', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '100px', maxWidth: '150px' } },
    ];

    const reportBannerText =
        dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
            ? `Daily APMS Escalated Complaints Report for (${officeName || getCompanies(companyCode)}) of ${convertDate(dateFrom)}`
            : `APMS Escalated Complaints for (${officeName || getCompanies(companyCode)}) from ${dateFrom ? convertDate(dateFrom) : '-'} to ${dateTo ? convertDate(dateTo) : '-'}`;

    const statsBar = (
        <div className="pc-apms-stats">
            <span className="pc-apms-stats__chip" style={{ backgroundColor: '#ffc107' }}>Pending: {totalPending}</span>
            <span className="pc-apms-stats__chip" style={{ backgroundColor: '#007bff', color: '#fff' }}>Allocated: {totalAllocated}</span>
            <span className="pc-apms-stats__chip" style={{ backgroundColor: '#17a2b8', color: '#fff' }}>Working: {totalWorking}</span>
            <span className="pc-apms-stats__chip" style={{ backgroundColor: '#ffb366', color: '#fff' }}>Onhold: {totalOnhold}</span>
            <span className="pc-apms-stats__chip" style={{ backgroundColor: '#107e10', color: '#fff' }}>Resolved: {totalResolved}</span>
            <span className="pc-apms-stats__chip" style={{ backgroundColor: '#fd7e14', color: '#fff' }}>SDO: {totalEscalatedToSDO}</span>
            <span className="pc-apms-stats__chip" style={{ backgroundColor: '#dc3545', color: '#fff' }}>SE: {totalEscalatedToSE}</span>
            <span className="pc-apms-stats__chip" style={{ backgroundColor: '#6f42c1', color: '#fff' }}>XEN: {totalEscalatedToXEN}</span>
            <span className="pc-apms-stats__chip" style={{ backgroundColor: '#003971', color: '#fff' }}>Total: {totalRecords}</span>
        </div>
    );

    return (
        <>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={viewBackdrop || exportLoading}>
                <AppLoader />
            </Backdrop>

            <ComplaintsReportShell
                pageTitle="APMS Escalated Complaints"
                bannerText={reportBannerText}
                exportStripStart={statsBar}
                isExportEmpty={!dataGrid?.length}
                onEmpty={noDataAvailable}
                onPdf={exportToPDF}
                onExcel={exportToExcel}
                onPrint={printPDF}
                filterProps={{
                    FilterComponent: APMSComplaintsFilters,
                    idPrefix: 'apms',
                    dateFrom,
                    setDateFrom,
                    dateTo,
                    setDateTo,
                    code,
                    hierarchy,
                    selectedCompanyCode,
                    onChangeCompany: handleChangeCompany,
                    circleCode,
                    onChangeCircle: handleCircleChange,
                    filteredCircles,
                    selectedDivision,
                    onChangeDivision: handleDivisionChange,
                    filteredDivisions,
                    selectedSubDivision,
                    onChangeSubDivision: handleSubDivisionChange,
                    filteredSubDivisions,
                    onGoClick: handleGoClick,
                    isGoDisabled,
                    viewBackdrop: viewBackdrop || exportLoading,
                    statusFilter,
                    onStatusFilterChange: setStatusFilter,
                    escalationFilter,
                    onEscalationFilterChange: setEscalationFilter,
                }}
            >
                <div className="div-datagrid">
                    <BasicTable
                        data={dataGrid}
                        columns={tblColumns}
                        handleRowClick={(params) => { handleRowClick(params) }}
                        sx={tableStyle}
                        rowHeight={37.5}
                        pageSize={pageSize}
                        rowsPerPageOptions={[20, 50, 100]}
                        nextPage={handleNextPage}
                        firstPage={handleFirstPage}
                        lastPage={handleLastPage}
                        previousPage={handlePreviousPage}
                        totalPages={totalPages}
                        totalRecords={totalRecords}
                        currentPage={pageNumber}
                        rowsPageOption={false}
                        isLoading={viewBackdrop}
                        getRowStyle={(params) => {
                            return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                        }}
                    />
                </div>
            </ComplaintsReportShell>
        </>
    );
};

export default APMSEscalatedComplaints;